import { h } from 'preact'
import style from './styles/dots.scss'

const Dots = () => (
  <div class={style.normal}>
    <div>
      <div></div>
    </div>
    <div>
      <div></div>
    </div>
    <div>
      <div></div>
    </div>
    <div>
      <div></div>
    </div>
    <div>
      <div></div>
    </div>
  </div>
)

export default Dots



// WEBPACK FOOTER //
// ./components/ChatBot/Dots.js